import { get } from "lodash";
import { REQUEST_CHAT, DF_RECEIVE_CHAT, SET_CASE_ID, REQUEST_CHAT_AN_ADVISOR, DF_CREATE_LIVE_AGENT_SESSION, DF_INIT_CHASITOR, RECEIVE_CHAT_AN_ADVISOR, DF_REQUEST_CREATE_SESSION, DF_RECEIVE_CREATE_SESSION, DF_REQUEST_INIT_CHASITOR, DF_RECEIVE_INIT_CHASITOR, DF_MESSAGES, DF_RECEIVE_MESSAGES, SET_SEQUENCE, DF_CHAT_END, DF_REQUEST_CLIENT_END_CHAT, DF_RECEIVE_CLIENT_END_CHAT, RECEIVE_CHAT, DF_RESET_QUEUE_JOIN_MESSAGE, GO_TO_ERROR_SCREEN, DF_TIMED_QUEUE_JOIN_MESSAGE } from "./Constants.js";
import { MESSAGE_TYPE, CHAT_STATUS } from "../constants/index.js";
import run from "../utils/retry.js";
import { setChatStatus, cyclePositionMessage, setChatbotSending } from "./ChatActions.js";
import createCase from "../utils/createCase.js";
import { isAdvisorHandoverAvailable } from "../utils/advisorHandover.js";
let controller = null;
function cancelInitMessageRequest() {
  if (controller) {
    controller.abort();
    controller = null;
  }
}
const getApiVersion = (apiClient) => {
  var _a, _b;
  return ((_b = (_a = apiClient.chatConfig) == null ? void 0 : _a.liveagent) == null ? void 0 : _b.apiVersion) || 54;
};
function setCaseId(caseId) {
  return {
    type: SET_CASE_ID,
    caseId
  };
}
function requestCreateSession() {
  return {
    type: DF_REQUEST_CREATE_SESSION
  };
}
function receiveCreateSession(result) {
  return {
    type: DF_RECEIVE_CREATE_SESSION,
    result
  };
}
function fetchCreateSession(apiClient) {
  return async (dispatch, getState) => {
    dispatch(requestCreateSession());
    let result = {};
    try {
      const apiVersion = getApiVersion(apiClient);
      result = await apiClient.get(DF_CREATE_LIVE_AGENT_SESSION, null, null, {
        "X-LIVEAGENT-AFFINITY": "null",
        "X-LIVEAGENT-API-VERSION": apiVersion
      });
    } catch (e) {
      throw new Error(e);
    }
    dispatch(receiveCreateSession(result));
  };
}
function requestInitChasitor() {
  return {
    type: DF_REQUEST_INIT_CHASITOR
  };
}
function receiveInitChasitor() {
  return {
    type: DF_RECEIVE_INIT_CHASITOR
  };
}
function fetchInitChasitor(apiClient) {
  return async (dispatch, getState) => {
    var _a;
    dispatch(requestInitChasitor());
    const chatConfiguration = getState().chat;
    const sessionKey = chatConfiguration.chatBot.dfKey;
    const affinity = chatConfiguration.chatBot.dfAffinity;
    const caseId = chatConfiguration.chatBot.dfCaseId || chatConfiguration.config.caseId;
    const sessionDetails = chatConfiguration.chatBot.session ? [
      {
        label: "Session Key",
        value: chatConfiguration.chatBot.session,
        entityMaps: [],
        transcriptFields: [],
        displayToAgent: false
      },
      {
        label: "Session Id",
        value: chatConfiguration.chatBot.session,
        entityMaps: [],
        transcriptFields: [],
        displayToAgent: false
      }
    ] : [];
    const prechatDetails = [
      {
        displayToAgent: true,
        entityMaps: [],
        label: "Parcel Code",
        transcriptFields: [],
        value: chatConfiguration.config.parcelCode
      },
      {
        displayToAgent: true,
        entityMaps: [
          {
            entityName: "Case",
            fieldName: "Id"
          }
        ],
        label: "CaseId",
        transcriptFields: ["CaseId"],
        value: caseId
      },
      {
        label: "Chatbot",
        value: true,
        entityMaps: [],
        transcriptFields: [],
        displayToAgent: true
      },
      {
        label: "Reason",
        value: apiClient.chatConfig.additionalDetails.reason || "",
        entityMaps: [],
        transcriptFields: [],
        displayToAgent: true
      },
      {
        label: "Platform",
        value: apiClient.chatConfig.additionalDetails.platform,
        entityMaps: [],
        transcriptFields: [],
        displayToAgent: true
      },
      ...sessionDetails
    ];
    const prechatEntities = [
      {
        entityName: "Case",
        saveToTranscript: "CaseId",
        showOnCreate: false,
        linkToEntityName: "Case",
        linkToEntityField: "CaseId",
        entityFieldsMaps: [
          {
            fieldName: "id",
            label: "CaseId",
            doFind: true,
            isExactMatch: true,
            doCreate: false
          }
        ]
      }
    ];
    const {
      platinumDeploymentId,
      eliteDeploymentId,
      organizationId,
      platinumButtonId,
      eliteButtonId
    } = apiClient.chatConfig.liveagent;
    const accountQueue = ((_a = chatConfiguration.config) == null ? void 0 : _a.queueType) || "Platinum";
    const body = {
      organizationId,
      deploymentId: accountQueue === "Platinum" ? platinumDeploymentId : eliteDeploymentId,
      buttonId: accountQueue === "Platinum" ? platinumButtonId : eliteButtonId,
      sessionId: chatConfiguration.chatBot.dfId,
      userAgent: "DPD Online Consumer",
      language: "en-GB",
      screenResolution: "1920x1080",
      visitorName: "",
      prechatDetails,
      prechatEntities,
      receiveQueueUpdates: true,
      isPost: true
    };
    const headers = {
      "Content-Type": "application/json",
      "X-LIVEAGENT-AFFINITY": affinity,
      "X-LIVEAGENT-SESSION-KEY": sessionKey,
      "X-LIVEAGENT-SEQUENCE": 1,
      "X-LIVEAGENT-API-VERSION": getApiVersion(apiClient)
    };
    try {
      await run(async () => {
        await apiClient.post(DF_INIT_CHASITOR, null, null, body, headers);
      }, 5);
    } catch (e) {
      throw new Error(e);
    }
    dispatch(receiveInitChasitor());
  };
}
function setSequence(sequence) {
  return {
    type: SET_SEQUENCE,
    sequence
  };
}
function receiveMessages(messages) {
  return {
    type: DF_RECEIVE_MESSAGES,
    messages
  };
}
function getAdvisorMessage({ chatId, ack, local, apiClient }) {
  return async (dispatch, getState) => {
    dispatch(cyclePositionMessage());
    const { dfKey, dfAffinity, dfId } = getState().chat.chatBot;
    if (chatId !== dfId) {
      return;
    }
    let result = null;
    const url = DF_MESSAGES + "?ack=" + ack;
    try {
      await run(async () => {
        result = await apiClient.get(url, null, null, {
          "X-LIVEAGENT-AFFINITY": dfAffinity,
          "X-LIVEAGENT-SESSION-KEY": dfKey,
          "X-LIVEAGENT-API-VERSION": getApiVersion(apiClient)
        });
      }, 5);
    } catch (e) {
      throw new Error(e);
    }
    if (result == null ? void 0 : result.messages) {
      dispatch(receiveMessages(result.messages));
    }
    let newAck = ack + 1;
    if ((result == null ? void 0 : result.type) === "ChatMessage") {
      newAck = result.sequence;
      dispatch(setSequence(result.sequence - 1));
    }
    const messageType = get(result, "messages[0].type", "");
    if (messageType !== MESSAGE_TYPE.CHAT_ENDED && messageType !== MESSAGE_TYPE.CHAT_REQUEST_FAIL) {
      dispatch(getAdvisorMessage({ chatId, ack: newAck, local, apiClient }));
    }
  };
}
function receiveChatMessage() {
  return {
    type: DF_RECEIVE_CHAT
  };
}
function sendVisitorMessage(message, apiClient) {
  return async (dispatch, getState) => {
    if (message.trim() === "") {
      return;
    }
    const chatState = getState().chat.chatBot;
    const { dfKey, dfSequence, dfAffinity } = chatState;
    const messageEndpoint = "/chat/rest/Chasitor/ChatMessage";
    const headers = {
      "Content-Type": "application/json",
      "X-LIVEAGENT-API-VERSION": getApiVersion(apiClient),
      "X-LIVEAGENT-AFFINITY": dfAffinity,
      "X-LIVEAGENT-SESSION-KEY": dfKey,
      "X-LIVEAGENT-SEQUENCE": (dfSequence || 2).toString()
      // Ensure it's a string
    };
    const body = {
      text: message
    };
    await run(async () => {
      await apiClient.post(messageEndpoint, null, null, body, headers);
    });
    dispatch({ type: REQUEST_CHAT, message });
    dispatch(receiveChatMessage());
  };
}
function requestChatEnd() {
  return {
    type: DF_REQUEST_CLIENT_END_CHAT
  };
}
function receiveChatEnd() {
  return {
    type: DF_RECEIVE_CLIENT_END_CHAT
  };
}
function resetQueueJoinMessage() {
  return {
    type: DF_RESET_QUEUE_JOIN_MESSAGE
  };
}
function timedQueueJoinMessage() {
  return {
    type: DF_TIMED_QUEUE_JOIN_MESSAGE
  };
}
function fetchChatEnd(apiClient) {
  return async (dispatch, getState) => {
    const state = getState().chat;
    if (state.chatBot.state === CHAT_STATUS.CALL_CENTER_CLOSED) {
      return;
    }
    dispatch(requestChatEnd());
    const { dfKey, dfAffinity } = getState().chat.chatBot;
    const headers = {
      "X-LIVEAGENT-AFFINITY": dfAffinity,
      "X-LIVEAGENT-SESSION-KEY": dfKey,
      "X-LIVEAGENT-SEQUENCE": state.chatBot.dfSequence || 1,
      "X-LIVEAGENT-API-VERSION": getApiVersion(apiClient)
    };
    const body = {
      reason: "client"
    };
    await apiClient.post(DF_CHAT_END, null, null, body, headers);
    dispatch(receiveChatEnd());
  };
}
function requestChatAnAdvisor() {
  return {
    type: REQUEST_CHAT_AN_ADVISOR
  };
}
function goToErrorScreen() {
  return {
    type: GO_TO_ERROR_SCREEN
  };
}
function receiveChatAnAdvisor(caseId, id, message, agentUrl, sessionKey, affinityToken) {
  return {
    type: RECEIVE_CHAT_AN_ADVISOR,
    caseId,
    id,
    message,
    agentUrl,
    sessionKey,
    affinityToken
  };
}
function initiateAdvisorChat(apiClient) {
  return async (dispatch, getState) => {
    var _a, _b, _c;
    const chatConfiguration = getState().chat;
    const config = chatConfiguration.config;
    if (!isAdvisorHandoverAvailable({}, config)) {
      dispatch(setChatStatus(CHAT_STATUS.ADVISOR_BUSY));
      return;
    }
    const normalizedValues = {
      reasonForContact: "Chat",
      contactDetails: {
        name: "Chat User",
        email: "chat@dpd.co.uk"
        // This should be the actual user's email
      }
    };
    if ((_a = chatConfiguration == null ? void 0 : chatConfiguration.config) == null ? void 0 : _a.parcelCode) {
      normalizedValues.parcelCode = chatConfiguration.config.parcelCode;
      if (chatConfiguration.config.postCode) {
        normalizedValues.postcode = chatConfiguration.config.postCode;
      } else if (chatConfiguration.config.orderId) {
        normalizedValues.orderId = chatConfiguration.config.orderId;
      }
    } else if ((_b = chatConfiguration == null ? void 0 : chatConfiguration.config) == null ? void 0 : _b.collectionReference) {
      normalizedValues.collectionReference = chatConfiguration.config.collectionReference;
      normalizedValues.collectionPostcode = chatConfiguration.config.collectionPostcode;
    }
    const options = {
      createParcelClaim: (claimData) => apiClient.createParcelClaim(claimData),
      errorMessage: "Failed to create case for advisor handover.",
      onSuccess: () => {
      },
      onError: () => {
      },
      overlay: null
    };
    const caseId = await createCase(normalizedValues, options);
    await dispatch(setCaseId(caseId));
    dispatch(requestChatAnAdvisor());
    if (!caseId) {
      dispatch(setChatStatus(CHAT_STATUS.ADVISOR_BUSY));
      return;
    }
    const isAdvisorAvailable = await dispatch(checkIfAdvisorIsAvailable());
    if (!isAdvisorAvailable) {
      dispatch(setChatStatus(CHAT_STATUS.ADVISOR_BUSY));
      return;
    }
    try {
      await dispatch(fetchCreateSession(apiClient));
      dispatch({ type: "SET_SEQUENCE", sequence: 2 });
      await dispatch(fetchInitChasitor(apiClient));
      const { dfId, dfKey, dfAffinity } = getState().chat.chatBot;
      const liveAgentUrl = (_c = apiClient.chatConfig.liveagent) == null ? void 0 : _c.host;
      dispatch(
        receiveChatAnAdvisor(
          caseId,
          dfId,
          "Advisor chat initiated successfully",
          liveAgentUrl,
          dfKey,
          dfAffinity
        )
      );
      dispatch(
        getAdvisorMessage({
          chatId: dfId,
          ack: 0,
          local: dfId,
          apiClient
        })
      );
    } catch (e) {
      dispatch(setChatStatus(CHAT_STATUS.ADVISOR_BUSY));
    }
  };
}
function checkIfAdvisorIsAvailable() {
  return (dispatch, getState) => {
    var _a;
    const chatState = getState().chat;
    const isAvailable = (_a = chatState.config) == null ? void 0 : _a.advisorAvailable;
    return isAvailable;
  };
}
function initiateChat(apiClient, isDirectCall = false) {
  return async (dispatch, getState) => {
    var _a, _b;
    dispatch(resetQueueJoinMessage());
    const state = getState().chat;
    const botAvailable = (_a = state.config) == null ? void 0 : _a.botAvailable;
    if ((_b = state.chatBot) == null ? void 0 : _b.alreadyWelcomed) {
      return;
    }
    let silentMessage = "welcome";
    if (state.chatBot.alreadyWelcomed) {
      silentMessage = "welcome-back";
    }
    if (state.config.flag === "inflight-success") {
      silentMessage = "inflight-success";
    }
    if (botAvailable === false) {
      await dispatch(initiateAdvisorChat(apiClient));
    } else {
      try {
        const welcomeResponse = await apiClient.get("/chat/welcome");
        const welcomeMessage = welcomeResponse.welcomeMessage || welcomeResponse;
        const formWelcomeDispatchObj = (welcomeMessage2) => ({
          messages: [
            {
              type: "welcome",
              message: welcomeMessage2
            }
          ],
          suggestions: []
        });
        const dispatchObj = formWelcomeDispatchObj(welcomeMessage);
        dispatch({
          type: RECEIVE_CHAT,
          result: dispatchObj
        });
        try {
          controller = new AbortController();
          dispatch(setChatbotSending(true));
          const config = getState().chat.config;
          const botResponse = await apiClient.post(
            "/chat/message",
            null,
            null,
            {
              message: "Hello",
              parcelCode: config == null ? void 0 : config.parcelCode,
              init: true,
              topicId: config == null ? void 0 : config.topicId,
              ...silentMessage && silentMessage.trim() !== "" ? { silentMessage } : {}
            },
            {},
            controller.signal
          );
          if (botResponse && botResponse.messages) {
            dispatch({
              type: RECEIVE_CHAT,
              result: {
                messages: botResponse.messages,
                suggestions: botResponse.suggestions || []
              }
            });
            if (!config.botAvailable) {
              if (isAdvisorHandoverAvailable(botResponse, config)) {
                await dispatch(initiateAdvisorChat(apiClient));
              } else {
                dispatch(setChatStatus(CHAT_STATUS.ADVISOR_BUSY));
              }
            }
          }
        } catch (error) {
          dispatch({
            type: RECEIVE_CHAT,
            result: {
              messages: [
                {
                  type: "default",
                  message: "The chatbot is unavailable at the moment. Please try again later."
                }
              ],
              suggestions: []
            }
          });
        } finally {
          dispatch(setChatbotSending(false));
          if (controller) {
            controller.abort();
            controller = null;
          }
        }
      } catch (error) {
        dispatch({
          type: RECEIVE_CHAT,
          result: {
            messages: [
              {
                type: "default",
                message: "The chatbot is unavailable at the moment. Please try again later."
              }
            ],
            suggestions: []
          }
        });
        dispatch(setChatbotSending(false));
      }
    }
    const { state: chatState, dfCaseId } = getState().chat.chatBot;
    if (chatState === CHAT_STATUS.CALL_CENTER_CLOSED || apiClient.chatConfig.isSalesforceCaseRequired && !dfCaseId) {
      return dispatch(goToErrorScreen());
    }
    if (chatState !== CHAT_STATUS.ADVISOR_BUSY) {
      setTimeout(() => {
        dispatch(timedQueueJoinMessage());
      }, 2e4);
    }
  };
}
export {
  cancelInitMessageRequest,
  checkIfAdvisorIsAvailable,
  fetchChatEnd,
  fetchCreateSession,
  fetchInitChasitor,
  initiateAdvisorChat,
  initiateChat,
  sendVisitorMessage,
  setCaseId
};
//# sourceMappingURL=LiveActions.js.map
